// TODO: Write a protected route that will redirect to login if the user is not logged in

// import AuthContext from 'contexts/AuthContext';
import React from "react";
import { Navigate } from "react-router-dom";
import { getUserDetails } from "../utils/utils";

function ProtectedRoutes({ element }) {
  const { email } = getUserDetails();  
  if (!email || email === "") {
    return <Navigate to="/" />;
  }
  return <>{element}</>;
}

export default ProtectedRoutes;
